import {ApiService} from "./api.service";
import {Injectable} from "@angular/core";

@Injectable()
export class UserService {
    constructor(private apiService: ApiService)
    {}

    public getSignupValues() {
        return this.apiService.get('static-content.php')
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }

    public register(name: string, mail: string, password: string, field_user_company: string, field_user_fullname: string,
                    field_user_address: string, field_abonnement: string, agree: boolean) {

        return this.apiService.post('user/register',{
            name: [{value:name}],
            mail: [{value:mail}],
            field_user_company: [{value: field_user_company}],
            field_user_fullname: [{value: field_user_fullname}],
            field_user_address: [{value: field_user_address}],
            pass: [{value: password}],
            field_abonnement: [{value: field_abonnement}],
            field_agree: [{value: agree}]
        })
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }

    public login(name: string, password: string) {
        return this.apiService.post('user/login', {
            name: name,
            pass: password,
            form_id: 'user_login_form'
        }).map((res) => {
                return ApiService.extractData(res);
        }).catch((err) => {
            return ApiService.handleError(err, true);
        });
    }

    public logout() {
        window.location.href = '/cms/deletesession.php';
        ApiService.eraseToken();
        return this.apiService.post('user/logout?_format=json').map((res) => {
            return ApiService.extractData(res);
        }).catch((err) => {
            return ApiService.handleError(err, true);
        });
    }
}


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/services/user.service.ts